import type { FloorExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const floorResolver =
  createSimpleNamedExpressionResolver<FloorExpression>('floor', Math.floor);
